import { Component } from 'react';

export default class DataGridMultiSelectFloatingFilter extends Component {
    constructor(props) {
        super(props);
        this.state = { selectedCount: 0 };
    }

    onParentModelChanged = (model) => {
        const values = model?.value ?? [];
        this.setState({ selectedCount: Array.isArray(values) ? values.length : 0 });
    };

    render() {
        const { selectedCount } = this.state;
        const displayText = selectedCount === 0 ? 'All' : `${selectedCount} selected`;
        return (
            <span
                className="form-control form-control-sm mt-2"
                style={{
                    lineHeight: '1.6',
                    cursor: 'default',
                }}
            >
                {displayText}
            </span>
        );
    }
}
